import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { CreateChancel, Input } from 'components';
import { FindLoad, FindSuccessItem, useModal } from 'utils';
import { httpRequestsOnSuccessActions, systemActions } from 'store';

export const CreateEditDepartment = ({ info, afterSuccess }) => {
    const dispatch = useDispatch();
    const ACTION_TYPE = info ? 'EDIT_DEPARTMENT_BY_ID_GLOBAL' : 'CREATE_DEPARTMENT_GLOBAL';
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const { close } = useModal();

    const {
        control,
        handleSubmit,
        reset,
    } = useForm({
        defaultValues: {
            name: '',
        }
    });

    useEffect(() => {
        if (info) {
            reset({
                name: info.name || '',
            });
        }
    }, [info, reset]);

    useEffect(() => {
        if (!!success) {
            if (afterSuccess) afterSuccess();
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            reset();
        }
    }, [success]);

    function handleSave(data) {
        if (info) {
            dispatch(systemActions.editDepartmentByIdGlobal(data, info.id));
        } else {
            dispatch(systemActions.createDepartmentGlobal(data));
        }
    }

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">{info ? 'Edit Department' : 'Add Department'}</p>
            <form onSubmit={handleSubmit(handleSave)}>
                <div className="modal-body-wrapper">
                    <Input
                        name="name"
                        label="Department Name*"
                        variant="outlined"
                        control={control}
                        maxLength={50}
                        rules={{
                            required: 'Department name is required.',
                            maxLength: {
                                value: 50,
                                message: 'Max length is 50 characters.',
                            },
                        }}
                    />
                </div>

                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={info ? 'Save' : 'Add'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                />
            </form>
        </div>
    );
};
